<template>
  <div class="container">
    <div class="" id="jump0">
      <div class="head">
        <div class="headLogo" @click="$router.push('/')">
          <img class="headLogo_img" src="../../static/img/logo.png" alt="" />
          <div class="headLogo_title">Быстрые займы.kz</div>
        </div>
        <div class="headMinu">
          <div class="headAbout">
            <div :class="index == 1 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(1)">О нас</div>
            <div :class="index == 2 ? 'headAbout_text' : 'headAbout_textTwo'" @click="goFn(2)">Как его получить?</div>
          </div>
          <div class="headLang">
            <div class="headLang_e">QZ</div>
            <div class="headLang_h">RU</div>
          </div>
          <div class="head_btn" @click="getlogin">Bойти</div>
        </div>
      </div>
    </div>

    <!-- 下载  -->
    <div class="introduce">
      <div class="introduce_title">Страховка</div>
    </div>

    <!-- 内容 -->
    <div style="padding: 0 2.41rem;">
      <div class="loa">
        <div class="ind">Вы можете оформить страховку через нашего партнера.</div>
        <div class="oiq">
          <img src="../../static/img/nomad.png" class="iud" alt="" />
          <div class="iio">Оформить</div>
        </div>
      </div>
      <div class="ila">
        <div :class="lifeshow ? 'oia' : 'iop'">
          <div class="iuj">Условия страхования Nomad Life</div>
          <img class="mjl" :src="lifeshow ? '../../static/img/gb.png' : '../../static/img/dk.png'" @click="lifeclick" alt="" />
        </div>
        <!-- <div class="ika">
          АО «КСЖ «Nomad life» предлагает онлайн страхование от несчастного случая с покрытием временной нетрудоспособности. Стоимость страховки – 30 000 ₸, срок действия 20 дней.
        </div> -->
        <div class="ioq" v-if="lifeshow">
          <div class="oif" style="margin-bottom: 0.14rem;" @click="lifeinsurance">
            <img class="poi" src="../../static/img/xz.png" alt="" />
            <div class="mnj">Заявление на добровольное срочное страхование жизни</div>
          </div>
          <div class="oif" @click="lifeinsurancerules">
            <img class="poi" src="../../static/img/xz.png" alt="" />
            <div class="mnj">Правила добровольного срочного страхования  жизни</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="bom">
      <div class="bom_title">Наши Контакты</div>
      <img class="bom_bg" src="../../static/img/d.png" alt="" />
      <div style="display: flex;justify-content: space-between;">
        <div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/tel.png" alt="" />
            <div class="bom_min-text">+7 775 030 8686</div>
          </div>
          <!-- <div class="bom_min" @click="wafn">
            <img class="bom_min-img" src="../../static/img/wa.png" alt="" />
            <div class="bom_min-text">+{{WhatsAppphone}}</div>
          </div> -->
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/time.png" alt="" />
            <div class="bom_text">Пн-Пт 10:00-19:00 Сб, Вс выходные</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/email.png" alt="" />
            <div class="bom_min-text-two">Support@fcredit.kz</div>
          </div>
          <div class="bom_min">
            <img class="bom_min-img" src="../../static/img/add.png" alt="" />
            <div class="bom_min-two">Казахстан, город Алматы, Бостандыкский район, улица Еділ Ерғожин, здание 27, 46</div>
          </div>
        </div>

        <div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;margin-top: 0.08rem;" @click="$router.push('/')">Главная страница</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(1)">О нас</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(2)">Как его получить?</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="goFn(3)">документ</div>
          <div class="bom_min-text" style="margin-bottom: 0.21rem;" @click="homeFn(0)">Страховка</div>
        </div>

        <div>
          <div class="bom_text-two">Скачивай мобильное приложение через:</div>
          <div class="bomIMg" style="margin-bottom: 0.25rem">
            <img class="bom_img" style="margin-right: 0.1rem;" src="../../static/img/googleplay.png" alt="" @click="googleFn" />
            <img class="bom_img" src="../../static/img/AppStore.png" alt=""  @click="appstoreFn" />
          </div>
          <div class="payment_minu">
            <img class="payment_minu-img" style="margin-right: 0.1rem;" src="/static/img/mastercar.png" alt="" />
            <img class="payment_minu-img" src="/static/img/visa.png" alt="" />
          </div>
        </div>
      </div>
      <div class="iua">
        <img class="iua_q" @click="getwa" src="/static/img/waapp.png" alt="" />
      </div>
    <!-- 支付相关 -->
    <div class="payment">
        <div class="payment-line"></div>
        <div class="payment_text">ТОО «МФО ECKZ», Лицензия на осуществление микрофинансовой деятельности № 02.24.0011.М, от 12.09.2024 года,
          выдана Управлением региональных представителей в городе Алматы Агентства Республики Казахстан по регулированию
          и развитию финансового рынка.</div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    cfgIndex
  } from '@/api/info'
  export default {
    name: "Insurance",
    data() {
      return {
        index: 2,
        whatsappArr: '77476509659',
        lifeshow: false,
        WhatsAppphone: ''
      };
    },
    created() {
      this.cfgIndexfn()
    },
    methods: {
      // 获取全局配置
      cfgIndexfn(){
        cfgIndex().then(res => {
          let WhatsAppphone = res.data.data.WhatsAppphone
          this.whatsappArr = res.data.data.WhatsAppphone
          this.WhatsAppphone = WhatsAppphone.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
        })
      },
      // 跳转wa
      getwa(){
        location.href = 'https://sg.sobot.com/chat/h5/v7/index.html?sysnum=01c300067aff4d1d948990845d880606'
      },
      goFn(type) {
        this.index = type
        if (type == 1) {
          this.$router.push('/about')
        } else if(type == 2){
          this.$router.push('/tutorial')
        }else{
          this.$router.push('/document')
        }
      },
      homeFn(index) {
        if (index == 0) {
          document.querySelector("#jump" + index).scrollIntoView(true);
        }
      },
      getlogin(){
        this.$router.push('/login')
      },
      googleFn() {
        location.href =
          'https://play.google.com/store/apps/details?id=loan.mfo.credit.tez.money.cash.zaim.pay.bank.card'
      },
      appstoreFn() {
        location.href = 'https://h5.fcredit.kz'
        // this.$message({
        //   message: 'В стадии разработки'
        // });
      },
      wafn(){
        location.href = "https://api.whatsapp.com/send?phone=" + this.whatsappArr
      },
      lifeclick(){
        this.lifeshow = !this.lifeshow
      },
      lifeinsurance(){
        location.href = 'https://fcredit.kz/lifeinsurances.pdf'
      },
      lifeinsurancerules(){
        location.href = 'https://fcredit.kz/lifeinsurancerules.pdf'
      }
    },
  };
</script>

<style scoped>
 * {
   margin: 0;
   padding: 0;
 }
 .container {
   background: #F6F8F8;
 }
  .head {
    background: #FFFFFF;
    padding: 0.1rem 1.88rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .headLogo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headLogo_img {
    width: 0.25rem;
    height: 0.19rem;
    margin-right: 0.07rem;
  }

  .headLogo_title {
    width: 0.41rem;
    height: 0.19rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.08rem;
    color: #0aba08;
    font-style: normal;
    cursor: pointer;
  }

  .headMinu {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headAbout {
    width: 1.48rem;
    height: 0.23rem;
    line-height: 0.23rem;
    border-radius: 0.11rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.27rem;
    margin-right: 0.45rem;
  }

  .headAbout_text {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #999999;
    font-style: normal;
    cursor: pointer;
  }

  .headAbout_textTwo:hover{
    color: #06B804;
    cursor: pointer;
  }

  .headLang {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 0.29rem;
  }

  .headLang_e {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    border-radius: 0.02rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
    margin-right: 0.07rem;
  }

  .headLang_h {
    width: 0.17rem;
    height: 0.17rem;
    line-height: 0.17rem;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.08rem;
    color: #fff;
    font-style: normal;
  }

  .head_btn {
    width: 0.75rem;
    height: 0.23rem;
    line-height: 0.23rem;
    text-align: center;
    background: #0ABA08;
    border-radius: 0.03rem;
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.08rem;
    color: #FFFFFF;
    font-style: normal;
    cursor: pointer;
  }

  .introduce {
    padding: 0 1.88rem;
    height: 2.08rem;
    background-image: url(../../static/img/wjbg.png);
    background-position: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    margin-bottom: 0.63rem;
  }

  .introduce_title {
    height: 2.08rem;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.26rem;
    color: #FFFFFF;
    text-align: left;
    line-height: 2.08rem;
    font-style: normal;
  }

  /* 中间内容 */
  .loa{
    padding: 0.34rem 0.52rem 0.47rem;
    background: #FFFFFF;
    border-radius: 0.14rem;
    margin-bottom: 0.42rem;
  }

  .ind{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.14rem;
    color: #333333;
    text-align: center;
    font-style: normal;
    margin-bottom: 0.3rem;
  }

  .oiq{
    padding: 0.16rem 0.55rem;
    background: #F6F8F8;
    border-radius: 0.05rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .iud{
    width: 0.66rem;
    height: 0.2rem;
  }

  .iio{
    width: 1.51rem;
    height: 0.32rem;
    background: linear-gradient( 180deg, #FFBD00 0%, #FF9100 100%);
    border-radius: 0.08rem;
    font-family: SFProText, SFProText;
    font-weight: bold;
    font-size: 0.13rem;
    color: #FFFFFF;
    line-height: 0.32rem;
    text-align: center;
    font-style: normal;
  }

  .ila{
    padding: 0.18rem 0.38rem;
    background: #FFFFFF;
    border-radius: 0.14rem;
    margin-bottom: 0.21rem;
  }

  .oia{
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 0.01rem solid #E7E7E7;
    padding-bottom: 0.18rem;
  }

  .iop{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .iuj{
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 0.14rem;
    color: #333333;
    font-style: normal;
  }

  .mjl{
    width: 0.16rem;
    height: 0.16rem;
  }

  .ika{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.13rem;
    text-align: left;
    font-style: normal;
    margin-top: 0.15rem;
  }

  .ioq{
    margin-top: 0.19rem;
  }

  .oif{
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .poi{
    width: 0.16rem;
    height: 0.16rem;
    margin-right: 0.08rem;
  }

  .mnj{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #333333;
    line-height: 0.13rem;
    text-align: left;
    font-style: normal;
    text-decoration-line: underline;
  }

  .bom {
    border-top: 0.02rem solid #E0E0E0;
    padding: 0.44rem 1.96rem 0.24rem 1.88rem;
    background-color: #FFFFFF;
    position: relative;
  }
  .bom_bg{
    width: 2.6rem;
    height: 1.81rem;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .bom_title{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.18rem;
    color: #333333;
    font-style: normal;
    margin-bottom: 0.27rem;
  }
  .bom_min{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.2rem;
  }
  .bom_min-img{
    width: 0.23rem;
    height: 0.23rem;
    margin-right: 0.11rem;
  }
  .bom_min-text{
    font-family: Roboto, Roboto;
    font-weight: bold;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
    cursor: pointer;
  }
  .bom_min-text-two{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    font-style: normal;
  }
  .bom_min-two{
    width: 2.17rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
  .bom_text {
    width: 0.88rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.09rem;
    color: #333333;
    line-height: 0.13rem;
    font-style: normal;
  }
  .bom_texte{
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.1rem;
    color: #06B804;
    margin-bottom: 0.09rem;
    font-style: normal;
  }

  .bom_text-two {
   width: 1.06rem;
   font-family: Roboto, Roboto;
   font-weight: 400;
   font-size: 0.09rem;
   color: #666666;
   line-height: 0.13rem;
   font-style: normal;
   margin-bottom: 0.1rem;
  }
  .bomIMg {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .bom_img {
    width: 0.71rem;
    height: 0.21rem;
    cursor: pointer;
  }

  .payment {
    padding-right: 0.5rem;
    margin-top: 0.2rem;
  }
  .payment-line{
    width: 6.24rem;
    height: 0.01rem;
    background: #E3E3E3;
    margin-bottom: 0.2rem;
  }
  .payment_text {
    width: 5.46rem;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.07rem;
    color: #5C5C5C;
    line-height: 0.13rem;
    font-style: normal;
  }

  .payment_minu {
    width: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .payment_minu-img {
    width: 0.49rem;
    height: 0.31rem;
  }
  .iua{
    position: absolute;
    bottom: 1.25rem;
    right: 0.325rem;
  }
  .iua_q{
    width: 0.35rem;
    height: 0.35rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Insurance.vue